import React, { Component } from 'react';
import KuposModal from './KuposModal';
import SvgHome from './SvgHome';
import PropTypes from 'prop-types';
import { KuposButton } from '.';

export default class AtNoReturnTripsModal extends Component {
  static propTypes = {};

  render() {
    return (
      <div className="common-bip-info-modal">
        <KuposModal
          showModal={this.props.showModal}
          onHide={this.props.onHide}
          size="md"
          ariaLabel="login-modal"
        >
          <div className="bip-info-modal-container at-no-trips-modal">
            <div className="close-button pointer" onClick={this.props.onHide}>
              <SvgHome name="close" />
            </div>
            <div className="at-no-trips-body">
              <div className="no-return-trip-icon-container">
                <img src="/images/icons/home/calender-no-trips.png" />
              </div>
              <div className="center-text" style={{ marginTop: 15 }}>
                <span className="font12 ">{this.props.t('RESULTS_PAGE.NO_RETURN_TRIPS')}</span>
              </div>
            </div>

            <div className=" edit-bip-button bip-popup-button-container-edit">
              <KuposButton
                onClick={this.props.onContinue}
                className="bip-popup-button1 font12 bip-edit-button"
              >
                {this.props.t('RESULTS_PAGE.CONTINUE_BOOKING')}
              </KuposButton>
            </div>

            <div
              className=" edit-bip-button bip-popup-button-container-edit"
              style={{ marginTop: -5 }}
            >
              <KuposButton
                onClick={this.props.onCancel}
                className="bip-popup-button1 font12 bip-edit-button"
              >
                {this.props.t('RESULTS_PAGE.SKIP_BOOKING')}
              </KuposButton>
            </div>
          </div>
        </KuposModal>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/common/AtNoReturnTripsModal.js